export default {

    url: '/integration',
    template: '<manage-settings-integration company="vm.company"><manage-settings-integration/>',
    resolve: {
        company (CompanyResource, TokenService) {
            return CompanyResource.get({ id: TokenService.getCompanyId(), expand: 'languages' }).$promise;
        }
    },
    controller (company) {
        this.company = company;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/integration/index.js